import { inject, Injectable } from '@angular/core';
import { RmaLocalStorageKey, RmaLocalStorageService } from '@rma/generic/ng/local-storage';
import { SelectedContext } from './domain/profile-context.models';
const ContextKey: RmaLocalStorageKey = 'rmaContext';

/**
 * ContextStorageService
 *
 * Handles persistence and retrieval of the user's selected profile context in local storage.
 *
 * - Exposes methods to get, set, and remove the current {@link SelectedContext} from local storage.
 *
 */
@Injectable({
  providedIn: 'root',
})
export class ContextStorageService {
  private readonly localStorage = inject(RmaLocalStorageService);

  public getContext(): SelectedContext | null {
    return this.localStorage.getObject<SelectedContext>(ContextKey);
  }

  public setContext(context: SelectedContext): void {
    this.localStorage.setItem(ContextKey, context);
  }

  public removeContext(): void {
    this.localStorage.removeItem(ContextKey);
  }
}
